import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

/** Superfície padrão do site — papel branco, hairline, sombra sutil no hover. */
export function Card({ className, ...props }: ComponentProps<"div">) {
  return (
    <div className={cn("card-paper rounded-xl", className)} {...props} />
  );
}

/** Cabeçalho padronizado de seção: índice mono + título serifado + lead. */
export function SectionHeading({
  index,
  label,
  title,
  description,
  align = "left",
  className,
}: {
  index: string;
  label: string;
  title: string;
  description?: string;
  align?: "center" | "left";
  className?: string;
}) {
  const centered = align === "center";
  return (
    <div
      className={cn(
        "flex flex-col gap-4",
        centered ? "items-center text-center" : "items-start text-left",
        className,
      )}
    >
      <p className="flex items-center gap-2.5 font-mono text-[11px] font-medium tracking-[0.16em] uppercase">
        <span className="text-subtle">{index}</span>
        <span aria-hidden className="h-px w-6 bg-line" />
        <span className="text-accent">{label}</span>
      </p>
      <h2 className="max-w-2xl font-display text-[clamp(1.9rem,4.5vw,3rem)] leading-[1.08] font-semibold tracking-[-0.02em] text-balance">
        {title}
      </h2>
      {description && (
        <p className="max-w-xl text-base leading-relaxed text-muted-foreground text-pretty">
          {description}
        </p>
      )}
    </div>
  );
}
